import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import ProgramForm from './forms/ProgramForm';
import ProgramList from './lists/ProgramList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import ModalEditor from "./ModalEditor";
import TimeConfigEditor from "./TimeConfigEditor";
import ProgramPriceEditor from "./ProgramPriceEditor";

class ProgramEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Programok"}
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <ProgramList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Program"}
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <ProgramForm {...this.props} />
                </Editor>
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    <Box
                        theme="default"
                        header="Helyek"
                    >
                        <SelectorGrid
                            columns={{
                                "name": {header: 'Hely', width: 2, sortable: true, filterable: true}
                            }}
                            name={"locations"}
                            listfieldlabel={"name"}
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            {...this.props.getFieldProps("locations")}
                        />
                    </Box>
                }
                {
                    this.props.values[this.props.componentConfig.idfield] &&
                    <TimeConfigEditor
                        gridid={"ProgramTimeConfigList"}
                        presets={{program: this.props.values}}
                        isLoading={this.props.isLoading}
                        editor={ModalEditor}
                        selection={null}
                        listFilter={[
                            {
                                field: "program",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                    />
                }
                {
                    this.props.values[this.props.componentConfig.idfield] &&
                    <ProgramPriceEditor
                        gridid={"ProgramProgramPriceList"}
                        presets={{program: this.props.values}}
                        isLoading={this.props.isLoading}
                        editor={ModalEditor}
                        selection={null}
                        listFilter={[
                            {
                                field: "program",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                    />
                }
            </Fragment>
        );
    }
}

export default createEditor({
    componentName: "Program",
    WrappedComponent: ProgramEditor,
    props: {
        view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action, data, params};
        }
    }
});
